import React from 'react'
import { Element, Heading } from 'react-bulma-components'

interface JobTitleInterimAgencySettingsInformationsProps {
  textColor?: string
}

const JobTitleInterimAgencySettingsInformations: React.FC<
  JobTitleInterimAgencySettingsInformationsProps
> = ({ textColor }) => {
  return (
    <>
      <Element mb={2}>
        Les Coefficients Agences d'Intérim sont des multiplicateurs appliqués au taux horaire de
        base (SMIC) pour déterminer le coût final d'une journée de travail.
        <br /> Ces coefficients sont définis pour chaque métier et par association entre une agence
        d'intérim et un employeur.
      </Element>

      <Element mt={4} mb={3}>
        <Heading size={6} textColor={textColor} mb={2}>
          Coefficients Agences d'Intérim
        </Heading>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Coefficient Délégation
        </Element>
        <Element>
          Appliqué lorsque l'agence d'intérim s'occupe du recrutement complet : recherche de
          candidats, sélection et gestion administrative.
          <br /> Ce coefficient est généralement plus élevé car il inclut la prestation de sourcing.
        </Element>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Coefficient Gestion
        </Element>
        <Element>
          Appliqué lorsque l'entreprise propose directement le candidat à l'agence d'intérim, qui ne
          s'occupe alors que de la gestion administrative.
          <br /> Ce coefficient est plus faible car il n'inclut pas la partie recrutement.
        </Element>
      </Element>

      <Element mb={3} mt={5}>
        <Heading size={6} textColor={textColor} mb={2}>
          Gestion du coût horaire
        </Heading>
        <Element>
          Pour chaque métier, vous pouvez définir le coût horaire de deux manières :
        </Element>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Utilisation du SMIC
        </Element>
        <Element>
          En cochant cette option, le SMIC en vigueur sera utilisé comme base de calcul pour le coût
          horaire.
          <br /> Les coefficients de délégation et gestion seront alors appliqués sur cette base.
        </Element>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Plage de coût horaire personnalisée
        </Element>
        <Element>
          Si vous ne souhaitez pas utiliser le SMIC, vous pouvez définir une plage de coût horaire
          personnalisée avec un minimum et un maximum.
          <br />
          <br /> Cette plage permet de :
        </Element>
        <Element className="content">
          <Element renderAs="ul">
            <Element renderAs="li">Garantir un coût minimum pour le métier</Element>
            <Element renderAs="li">Limiter le coût maximum pour éviter les dépassements</Element>
            <Element renderAs="li">Offrir une flexibilité dans la négociation des taux</Element>
          </Element>
        </Element>
        <Element>
          <Element renderAs="i" textSize={7}>
            C'est l'agence d'intérim qui définira le coût horaire exact (dans la plage de coût
            horaire personnalisée) lors de l'attribution d'un intérimaire au métier.
            <br />
            Le coût horaire final est calculé en appliquant les coefficients de délégation ou
            gestion sur le taux horaire de base (SMIC ou plage personnalisée).
          </Element>
        </Element>
      </Element>
    </>
  )
}

export default JobTitleInterimAgencySettingsInformations
